import React, { useEffect, useMemo, useRef } from "react";
import L from "leaflet";
import * as esri from "esri-leaflet";
import "leaflet/dist/leaflet.css";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import poweredbyPACI from "../../assets/images/poweredbyPACI.jpeg";
import Logo from "../../assets/images/Branding/LOGO1.png";
import GoogleMapsIcon from "../../assets/images/google-maps.png";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

const Map = ({ photo, voter }) => {
  const map = useRef(null);
  const marker = useRef(null);

  const coordinates = useMemo(() => {
    if (voter) {
      return [voter.Y, voter.X];
    }
    return [];
  }, [voter]);

  useEffect(() => {
    var container = L.DomUtil.get("map");
    L.Marker.prototype.options.icon = DefaultIcon;

    if (container != null) {
      container._leaflet_id = null;
    }
    const googleStreet = L.tileLayer(
      "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}?apikey=AIzaSyC0i79nanl2fx5car_ENTBHhKNTwiKYJhI",
      {
        maxZoom: 20,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
        attributionControl: false,
      }
    );
    const googleSatellite = L.tileLayer(
      "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}?apikey=AIzaSyC0i79nanl2fx5car_ENTBHhKNTwiKYJhI",
      {
        maxZoom: 20,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
      }
    );
    const googleHybrid = L.tileLayer(
      "https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}?apikey=AIzaSyC0i79nanl2fx5car_ENTBHhKNTwiKYJhI",
      {
        maxZoom: 20,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
      }
    );

    // const arcBase = esri.tiledMapLayer({
    //   url: "https://kuwaitportal.paci.gov.kw/arcgisportal/rest/services/PACIArabic/MapServer",
    // });

    map.current = L.map("map", {
      center: [29.3759, 47.9774],
      zoom: 10,
      layers: [googleStreet, googleSatellite, googleHybrid],
      attributionControl: false,
    });

    const baseMaps = {
      "Google Streets": googleStreet,
      "Google Satellite": googleSatellite,
      "Google Hybrid": googleHybrid,
    };

    L.control.layers(baseMaps).addTo(map.current);
  }, []);

  useEffect(() => {
    if (voter && photo) {
      L.Marker.prototype.options.icon = DefaultIcon;

      const {
        name,
        aldaayira,
        committee,
        number_of_registration,
        area,
        status,
        school,
        Y,
        X,
      } = voter;

      if (marker.current) {
        marker.current.remove();
      }
      if (X && Y) {
        marker.current = L.marker([Y, X]).addTo(map.current);

        marker.current
          .bindPopup(
            "\u200e" +
              `
            <div class="card overflow-hidden">
  <h5 class="card-title text-center">${name}</h5>
  <div class="card-body p-0">
    <div dir='rtl' lang='ar' class="row">
      <div class="float-start col-5 d-none d-sm-block p-0">
        <img src= "${photo}" 
        
        class="rounded mx-auto d-block"
          style="max-width: 90%" alt="Avatar">
      </div>
      <div class="float-start col-5 d-block d-sm-none p-0">
        <img src= "${photo}"  class="rounded mx-auto d-block"
        style="max-width: 85%" alt="Avatar">
      </div>   
      <div class="float-end col-7 p-0">
        <div class="row text-end">
          <span class="col-5 col-lg-5 fw-bold p-r-1">
            
            الدائرة:
          </span>
          <span class="col-7  bg-light text-dark p-1 ">
            ${aldaayira}
          </span>
        </div>
        <div class="row text-end">
          <span class="col-5 col-lg-5 fw-bold p-r-1">
            
            المدرسة:
          </span>
          <span class="col-7  bg-light text-dark p-1 ">
            ${school}
          </span>
        </div>
        <div class="row text-end">
          <span class="col-5 col-lg-5 fw-bold p-r-1">
            
            اللجنة:
          </span>
          <span class="col-7  bg-light text-dark p-1 ">
            ${committee}
          </span>
        </div>
        <div class="row text-end">
          <span class="col-5 col-lg-5 fw-bold p-r-1">
            
            رقم القيد:
          </span>
          <span class="col-7  bg-light text-dark p-1 ">
            ${number_of_registration}
          </span>
        </div>
        <div class="row text-end">
          <span class="col-5 col-lg-5 fw-bold p-r-1">
            
            المنطقة:
          </span>
          <span class="col-7  bg-light text-dark p-1 ">
            ${area}
          </span>
        </div>
        <div class="row text-end">
          <span class="col-5 col-lg-5 fw-bold p-r-1">
            
            حالة القيد:
          </span>
          <span class="col-7  bg-light text-dark p-1 ">
            ${status ? status : "مقيد"}
          </span>
        </div>

      </div>
    </div> 
  </div>
  <div>            `,
            {
              offset: [1, 30],
              minWidth: 355,
            }
          )
          .openPopup();
        map.current.flyTo(marker.current.getLatLng(), 15, {
          duration: 1.5,
        });
      }
    }
  }, [photo, voter]);

  return (
    <>
      <div id="map-container">
        <div
          id="map"
          className="d-flex flex-column align-items-center justify-content-center mt-3 mb-2 align-self-center"
        />
        <div className="col-6 col-lg-3 overlay leaflet-bottom leaflet-left leaflet-control-attribution leaflet-control esri-truncated-attribution:hover esri-truncated-attribution text-center">
          <small>Developed by Q8MAPS</small>
        </div>
      </div>

      <div className="d-flex justify-content-center align-items-center flex-wrap my-3">
        <div className="w-100 d-flex justify-content-center align-items-center flex-wrap">
          <a
            href={`https://www.google.com/maps/search/` + coordinates.join(",")}
            className="btn btn-outline-dark my-3"
            target="_blank"
          >
            Google Maps{" "}
            <img
              src={GoogleMapsIcon}
              alt="Google Maps"
              style={{ width: "25px", height: "25px" }}
            />
          </a>
          <img
            src={Logo}
            alt="Logo"
            className="img-fluid  mx-2"
            style={{ borderRadius: "10px", width: "60px" }}
          />

          {
            <a
              //href={`https://kwfinder.page.link/${coordinates[1]}/${coordinates[0]}`}
              //href={`https://gis.paci.gov.kw/Location/${coordinates[1]}/${coordinates[0]}`?zoom=10}
             // href={`https://gis.paci.gov.kw/Location/${coordinates[1]}/${coordinates[0]/2822.449520973724}`}
             href={ `https://gis.paci.gov.kw/Location/${coordinates[1]}/${coordinates[0]}?scale=${15}`}
              //href={`https://kwfinder.page.link/${gT7a7}`}
             // https://gis.paci.gov.kw/Location/47.959904/29.273975
              className="btn btn-outline-dark my-3"
              target="_blank"
            >
              كويت فايندر
              <img
                src={poweredbyPACI}
                alt="Logo"
                className="img-fluid  mx-2"
                style={{ borderRadius: "10px", width: "30px", height: "30px" }}
              />
            </a>
          }
        </div>
        {
          <div>
            <span className="text-muted">powered by PACI</span>
            <img
              src={poweredbyPACI}
              alt="powered by PACI"
              className="img-fluid"
              style={{ borderRadius: "10px", width: "60px" }}
            />
          </div>
        }
      </div>
    </>
  );
};

export default Map;
